import React from 'react';

type LocationAddressProps = {
  locationAddress?: {
    longitude?: number;
    address?: string;
    latitude?: number;
  };
};

function LocationAddress({locationAddress}: LocationAddressProps) {
  return (
    <div className={'border-b border-b-[#e9eced] py-[13px] px-[10px]'}>
      <h5 className={'text-xs m-0 text-[#9fa1a4] mb-1'}>
        地址 <span className={'text-[#be0b0b]'}>*</span> ：
      </h5>
      <p className={'m-0'} data-test-id={'address'}>
        {locationAddress?.address}（緯度：{locationAddress?.latitude}，經度：
        {locationAddress?.longitude}）
      </p>
    </div>
  );
}

export default LocationAddress;
